import queryString from 'query-string';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';

import AuthLayout from '../../../components/AuthLayout';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
const { API_URL, ASSOCIATE_URL } = config;

const ResetPassword = ({ location, history, match: { params } }) => {
  const token = queryString.parse(location.search).token;
  const type = params.type;

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to reset your password?'
      )
    ) {
      let url = `${API_URL}/${type}/reset-password/change`;
      try {
        let response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify({ password }),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        });

        let responseData = await response.json();

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          if (type === 'associate') {
            window.location.href = ASSOCIATE_URL;
          } else {
            history.push('/');
          }
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <AuthLayout title="Create a new password" subtitle="Choose a strong password for your account.">
        <form className="auth-form" onSubmit={(e) => submitHandler(e)}>
          <label>New password</label>
          <div className="auth-password-field">
            <input
              className="form-control"
              type={showPassword ? 'text' : 'password'}
              placeholder="Set Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="auth-password-toggle"
            >
              {showPassword ? (
                <i
                  className="far fa-eye-slash"
                  style={{ color: '#888383', fontSize: '14' }}
                ></i>
              ) : (
                <i
                  className="far fa-eye"
                  style={{ color: '#888383', fontSize: '14' }}
                ></i>
              )}
            </span>
          </div>
          <button type="submit" className="btn btn-brand w-100">
            Submit
          </button>
        </form>
    </AuthLayout>
  );
};

export default withRouter(ResetPassword);
